import React from 'react';
import { useSelector } from 'react-redux';
import {
  selectOrderMessagesExpedition,
  selectOrderMessagesDelivery,
  selectOrderMessagesProduction,
  selectOrderMessagesProductionAndExpedition,
  selectOrderMessagesStore,
} from 'app/containers/OrderDetails/selectors';
import MessageOrder, {
  type MessageDepartment,
} from 'app/containers/OrderDetails/GeneralTab/MessageOrder';

interface MessageGroup {
  department: MessageDepartment;
  messages: string[];
}

const MessagesArea = () => {
  const messagesProduction = useSelector(selectOrderMessagesProduction);
  const messagesExpedition = useSelector(selectOrderMessagesExpedition);
  const messagesDelivery = useSelector(selectOrderMessagesDelivery);
  const messagesStore = useSelector(selectOrderMessagesStore);
  const messagesProductionAndExpedition = useSelector(
    selectOrderMessagesProductionAndExpedition,
  );

  const messageGroups: MessageGroup[] = [
    {
      department: 'manufacturing',
      messages: messagesProductionAndExpedition,
    },
    { department: 'manufacturing', messages: messagesProduction ?? [] },
    { department: 'shipping', messages: messagesExpedition ?? [] },
    { department: 'delivery', messages: messagesDelivery },
    { department: 'store', messages: messagesStore },
  ];
  const messageCount = messageGroups.reduce(
    (count, group) => count + group.messages.length,
    0,
  );

  if (messageCount > 0) {
    return (
      <div className="flex flex-col">
        <div className="text-xl mb-2">Messages ({messageCount})</div>
        <div>
          {messageGroups.map(group =>
            group.messages.map((message, index) => (
              <MessageOrder
                key={`${group.department}-${index}-${message}`}
                messageContent={message}
                department={group.department}
              />
            )),
          )}
        </div>
      </div>
    );
  }
  return null;
};

export default MessagesArea;
